<template>
  <div class="app app-project-experiment-detail v" v-if="detail">
    <template v-if="!visibleDetail">
      <div class="padding-08 no-flex">
        <div class="padding-08 fc-t bold">
          <span>{{ detail.projectName }} / {{ detail.stageName }} / {{ detail.taskName }}</span>
          <br />
          <span class="fs-huge">{{ detail.name }}</span>
        </div>
      </div>
      <div class="flex scroll-able-y v ">
        <van-cell-group>
          <van-cell title="状态">
            <van-tag :type="expEnum[detail.status].type" v-if="detail.status && expEnum[detail.status]">{{ expEnum[detail.status].name }}</van-tag>
          </van-cell>
          <van-cell title="创建人" :value="detail.createBy" />
          <van-cell title="开始时间" :value="detail.begTime.substr(0, 10)" />
          <van-cell title="结束时间" :value="detail.endTime.substr(0, 10)" v-if="detail.status === 'FINISH'" />
          <van-cell title="实验目的">
            <template #label>{{ detail.target || "暂无实验目的" }}</template>
          </van-cell>
          <!-- <van-cell title="实验准备">
          <template #label>{{ detail.preparation }}</template>
        </van-cell> -->
          <van-cell title="主要仪器">
            <template #label>
              <span v-html="detail.devList.map(d => `${d.devCode}: ${d.devName} ${d.devModel}`).join('<br />')"></span>
            </template>
          </van-cell>

          <!-- <van-cell title="实验步骤">
          <template #label>
            <div v-html="detail.stepInfo"></div>
          </template>
        </van-cell>
        <van-cell title="实验结果">
          <template #label>
            <div v-html="detail.resultInfo"></div>
          </template>
        </van-cell>
        <van-cell title="实验结论">
          <template #label>{{ detail.conclusion }}</template>
        </van-cell> -->


        </van-cell-group>
        <van-button round block type="info" class="nav-button " style="width: 80%;margin: 16px auto;" size="large"
          @click="toDetail">查看详情</van-button>
      </div>
    </template>
    <template v-else>
      <!-- <iframe ref="frame" :src="url" frameborder="0" width="100%" style="min-height: 100%;" v-if="url"></iframe> -->
       <div v-if="pdfSrc" class="pdf-container">
        <vue-pdf 
          v-for="page in numPages" 
          :key="page" 
          :src="pdfSrc" 
          :page="page"
          class="pdf-page"
        />
      </div>
      <template v-else>
        <van-empty description="加载中..." v-if="loading" />
        <van-empty description="暂无数据" v-else />
      </template>
    </template>

  </div>
</template>

<script>
import { getById, getRecordPreviewURL } from "@/api/project/experiment";
import { expEnum } from "@/enums/index";
import vuePdf from 'vue-pdf'
export default {
   components: {
    vuePdf
  },
  computed: {
    expId() {
      return this.$route.params.id;
    },
  },
  data() {
    return {
      detail: {},
      expEnum,
      typeEnum: {
        info: "fc-g",
        primary: "fc-p",
        success: "fc-s",
        danger: "fc-e",
      },
      url: null,
       pdfSrc: null,
      numPages: 0,
      loading: false,
      visibleDetail: false,
    };
  },
  mounted() {
    this.getDetailData();
  },
  methods: {

    getDetailData() {
      getById(this.expId).then((res) => {
        if (res) {
          this.detail = res;
          // this.getdevListData();
        } else {
        }
      });
    },
    toDetail() {
        // 其他环境使用 iframe 预览
        this.visibleDetail = true;
        this.loading = true;
        getRecordPreviewURL(this.detail.id).then(res => {
          if (typeof res === "string" && res.length > 0) {
             this.pdfSrc = res;
            vuePdf.createLoadingTask(res).promise.then((pdf) => {
              this.numPages = pdf.numPages;
            }).catch((error) => {
              console.log("pdfSrc error", error);
              this.pdfSrc = null;
            });
            
          } else {
            // this.url = null;
              this.pdfSrc = null;
          }
        }).finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>

<style lang="scss">
.app-project-experiment-detail {
  img {
    max-width: 100%;
  }
   .pdf-container {
     height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; // iOS 设备上的平滑滚动
    padding: 10px;
    box-sizing: border-box;
  }
  
  .pdf-page {
    margin-bottom: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    // 确保页面宽度适应容器
    width: 100%;
  }
}
</style>